import React from 'react';
import { FormattedMessage } from 'react-intl';

const TermsAndConditions = ({ darkTheme }) => {
  return (
    <div
      id="terms-policy"
      className="modal fade"
      role="dialog"
      aria-hidden="true">
      <div
        className="modal-dialog modal-lg modal-dialog-centered"
        role="document">
        <div className={'modal-content bg-secondary '}>
          <div className="modal-header">
            <h1 className={'modal-title text-white'}>
              <FormattedMessage id="tos-tac" defaultMessage="Terms & Policy" />
            </h1>
            <button
              type="button"
              className={'btn-close ' + (darkTheme ? 'btn-close-white' : '')}
              data-bs-dismiss="modal"
              aria-label="Close"
            />
          </div>
          <div className="modal-body p-4">
            <h3 className={'mb-3 mt-4 mt-4 text-white'}>
              <FormattedMessage id="tos-usage" defaultMessage=" Terms of Use" />
            </h3>
            <p className="text-white">
              <FormattedMessage
                id="tos-terms"
                defaultMessage="Each time you access and use this website and any
                 materials on this website, you agrree to these terms, which GO-NUMERIK may 
                 revise at any time. If you do not agree to these terms, do not this website 
                 and do not download any materials"
              />
            </p>
            <h5 className={'text-4 mt-4 text-white'}>
              <FormattedMessage
                id="tos-part1"
                defaultMessage="Part I – Information gonumerik collects and controls"
              />
            </h5>
            <p className="text-white">
              <FormattedMessage
                id="tos-collect"
                defaultMessage="Osedea does not collect or record any data relative to your
                personal life (such as your date of birth, your age, your personal
                interests, your political or religious preferences, etc.). We
                currently do not use a geolocalization tool, but it is essentiel
                for us to know where our website is being visited from. We might
                be using you IP adress in the near future for that purpose. If you
                do not wish to share this information you can use a tool such as a
                free VPN offered by Opera browser. You have the possibility to
                visit our website without sharing any of your data other than the
                IP. You are not required at all to share your information with us."
              />
            </p>
            <h5 className={'text-4 mt-4 ' + (darkTheme ? 'text-white' : '')}>
              <FormattedMessage
                id="tos-part2"
                defaultMessage="Part II – Information that gonumerik processes on your behalf"
              />
            </h5>
            <p className="text-white">
              <FormattedMessage
                id="tos-process"
                defaultMessage="We currently use cookies in order to provide you with a better
              browsing experience when visiting this website."
              />
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
